<template>
  <div style="padding: 20px; background: #fff" v-if="isShowFooterBtnPanel">
    <template v-for="(item, index) of curBtnList">
      <el-button
        v-if="!item.disabled"
        :type="item.type"
        :key="index"
        :disabled="item.disabled"
        @click="clickHandler(item.clickName, item.params)"
        class="fixed-bottom-btn"
        >{{ item.title }}
      </el-button>
    </template>
  </div>
</template>
<script>
  export default {
    name: 'DetailFooterButtons',
    props: {
      contractStatus: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        allBtnList: [
          {
            title: '关闭',
            type: 'danger',
            clickName: 'close',
            params: 1,
            key: 'close',
          },
          {
            title: '编辑',
            type: 'primary',
            clickName: 'edit',
            params: 1,
            key: 'edit',
          },
          {
            title: '提交',
            type: 'primary',
            clickName: 'submit',
            params: 1,
            key: 'submit',
          },
          {
            title: '保存',
            type: 'primary',
            clickName: 'save',
            params: 1,
            key: 'save',
          },
          {
            title: '通过',
            type: 'primary',
            clickName: 'pass',
            params: 1,
            key: 'pass',
          },
          {
            title: '驳回',
            type: 'danger',
            clickName: 'refuse',
            params: 1,
            key: 'refuse',
          },
          {
            title: '取消',
            type: 'primary',
            clickName: 'cancel',
            params: 1,
            key: 'cancel',
          },
        ],
        curBtnList: [],
        isShowFooterBtnPanel: true,
        history: null,
      };
    },
    mounted() {
      const pageMode = this.$route.query?.pageMode;
      if (pageMode == 0) {
        this.buttonStatusChange(pageMode, '');
      }
    },
    methods: {
      // 动态派发事件上去
      clickHandler(clickName, params) {
        this.$emit('btnHandler', clickName, params);
      },
      buttonStatusChange(pageMode, contractStatus) {
        this.curBtnList = this.allBtnList.map((item) => {
          if (pageMode == 0) {
            //新增页面按钮
            if (['submit', 'save', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (
            pageMode == 1 &&
            (contractStatus == 'ZT01' || contractStatus == 'ZT04') &&
            this.history == null
          ) {
            //详情页面,已保存和审批驳回状态
            if (['edit', 'submit', 'save', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 1 && this.history == true) {
            //详情页面,查看历史版本
            if (['cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 1 && contractStatus == 'ZT02') {
            //详情页面，待审批状态
            if (['cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 1 && contractStatus == 'ZT03') {
            //详情页面，已生效状态
            if (['close', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 1 && contractStatus == 'ZT05') {
            //详情页面，已关闭
            if (['cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 2) {
            //审批页面按钮
            if (['pass', 'refuse', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 3) {
            //续签页面按钮
            if (['submit', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 4) {
            //信息变更页面按钮
            if (['submit', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          } else if (pageMode == 5) {
            //关闭页面按钮
            if (['close', 'cancel'].includes(item.key)) {
              return item;
            } else {
              return {
                ...item,
                disabled: true,
              };
            }
          }
        });
        this.isShowFooterBtnPanel = true;
      },
    },
    watch: {
      contractStatus: {
        handler(val) {
          const pageMode = this.$route.query?.pageMode;
          this.history = this.$route.query?.history;
          console.log(pageMode, '地址栏的pageMode');
          this.buttonStatusChange(pageMode, val);
        },
        immediate: false,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
